<template>
    <div class="frame-wrapper">
        <slot></slot>
    </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, onUnmounted, provide, reactive, watch } from "vue";
    import { useRoute } from "vue-router";
    const route = useRoute();

    const sendFrameHeight = () => {
        let scrollHeight = Math.max(
            document.body.scrollHeight,
            document.body.offsetHeight,
            document.body.clientHeight,
        );
        const documentElementHeight = Math.max(
            document.documentElement.scrollHeight,
            document.documentElement.offsetHeight,
            document.documentElement.clientHeight
        );
        // TODO найти более лаконичное решение для расчета высоты фрейма
        scrollHeight = documentElementHeight > (scrollHeight + scrollHeight / 10) ? scrollHeight : documentElementHeight;
        window.parent.postMessage({
            type: "layout",
            height: scrollHeight,
        }, '*');
    }

    const globalProps = reactive<Record<string, unknown>>({})
    provide('globalProps', globalProps);

    onMounted(() => {
        window.parent.postMessage({
            type: "ready",
        }, '*');
        window.addEventListener("message", (e) => {
            if(e?.data?.type === 'props') {
                Object.entries(e?.data?.props).forEach(([key, value]: [string, unknown]) => {
                    globalProps[key] = value;
                })
            }
        })

        const html = document.querySelector('html')
        if(html) {
            html.style.overflowY = "hidden";
        }

        nextTick(() => {
            sendFrameHeight()
            setTimeout(() => {
                sendFrameHeight()
            }, 150)
        })

        for(let i = 1; i <= 5; i++) {
            setTimeout(() => {
                sendFrameHeight()
            }, 1000 * i)
        }
    })

    watch(() => route.fullPath, async () => {
        console.log("route fullPath updated", route.fullPath);
        sendFrameHeight()
    });

    onUnmounted(() => {
        const html = document.querySelector('html')
        if(html) {
            html.style.overflowY = "auto";
        }
    })
</script>

<style lang="scss">
.frame-wrapper {
    margin-bottom: 110px;
    @include lg() {
        margin-bottom: 90px;
    }
}
</style>

